import { taxonomyFilter, pagination, search } from './filters'
import { ARCHIVE } from './constants'

document.addEventListener('DOMContentLoaded', () => {
    const archives = document.querySelectorAll(`[${ARCHIVE}]`)

    if (archives.length > 0) {
        archives.forEach(archive => {
            taxonomyFilter(archive)
            pagination(archive)
            search(archive)
        })
    }
});
